import { Grid } from '@mui/material';
import {
  ResourceCard,
  ResourceCardContainer,
  ResourceCardContent,
  ResourceCardHeader,
  ResourceCardMetaItem,
  ResourceCardPrices,
  ResourceCardTitle,
} from '..';
import { courses, resources, videos } from './resources-mock';
import bgPostgraduate from '@/assets/images/png/graduation.png';
import { courseTypesLabels } from '@/constants/catalog/course';
import {
  courseTypeIconNames,
  externalResourceIconNames,
} from '@/constants/resources/resources-icons';
import { resourceImage } from '@/constants/resources/resources-images';
import { formatDurationWithModality } from '@/utils/format-duration-with-modality';
import { formatExternalInstitution } from '@/utils/format-external-institution';
import { formatVideoDurationWithChannel } from '@/utils/format-video-duration';

export const ResourceCardExamples = () => {
  return (
    <>
      <Grid container spacing={2}>
        {videos.map((video) => (
          <Grid size={{ xs: 12, sm: 4, md: 3 }} key={video.uuid}>
            <ResourceCard>
              <ResourceCardHeader
                image={{
                  src: video.thumbnail_url,
                  alt: video.revisioned_title,
                  type: 'video',
                }}
              />
              <ResourceCardContainer>
                <ResourceCardTitle>{video.revisioned_title}</ResourceCardTitle>
                <ResourceCardContent>
                  <ResourceCardMetaItem icon="PlayCircleOutline">
                    Vídeo
                  </ResourceCardMetaItem>
                  <ResourceCardMetaItem icon="AccessTime">
                    {formatVideoDurationWithChannel(
                      video.duration_in_seconds,
                      video.channel_title
                    )}
                  </ResourceCardMetaItem>
                </ResourceCardContent>
              </ResourceCardContainer>
            </ResourceCard>
          </Grid>
        ))}

        {courses.map((course) => (
          <Grid size={{ xs: 12, sm: 4, md: 3 }} key={course.id}>
            <ResourceCard href="/dev/product-cards">
              <ResourceCardHeader
                institution={{
                  ...course.institution,
                  about: '',
                }}
              />
              <ResourceCardContainer>
                <ResourceCardTitle>{course.course_name}</ResourceCardTitle>
                <ResourceCardContent>
                  <ResourceCardMetaItem
                    icon={courseTypeIconNames[course.course_type.type]}
                  >
                    {course.course_type.label}
                  </ResourceCardMetaItem>
                  <ResourceCardMetaItem icon="AccessTime">
                    {formatDurationWithModality(
                      course.duration.quantity,
                      course.duration.type,
                      course.modalities[0]?.type
                    )}
                  </ResourceCardMetaItem>
                </ResourceCardContent>
                <ResourceCardPrices
                  discountPercentage={course.discount_percentage}
                  installments={course.installments}
                  offersQuantity={course.offers_quantity}
                  originalPrice={course.original_price}
                  priceType={course.price_type}
                  priceWithDiscount={course.price_with_discount}
                />
              </ResourceCardContainer>
            </ResourceCard>
          </Grid>
        ))}

        {resources.map((resource) => {
          if (resource.course) {
            return (
              <Grid size={{ xs: 12, sm: 4, md: 3 }} key={resource.course.id}>
                <ResourceCard href="/dev/product-cards">
                  <ResourceCardHeader
                    institution={formatExternalInstitution(resource.course)}
                  />
                  <ResourceCardContainer>
                    <ResourceCardTitle>
                      {resource.course.name}
                    </ResourceCardTitle>
                    <ResourceCardContent>
                      <ResourceCardMetaItem
                        icon={courseTypeIconNames[resource.course.course_type]}
                      >
                        {courseTypesLabels[resource.course.course_type]}
                      </ResourceCardMetaItem>
                      <ResourceCardMetaItem icon="AccessTime">
                        {formatDurationWithModality(
                          resource.course.duration,
                          resource.course.duration_type,
                          resource.course.modality
                        )}
                      </ResourceCardMetaItem>
                    </ResourceCardContent>
                  </ResourceCardContainer>
                </ResourceCard>
              </Grid>
            );
          }

          if (resource.external_link) {
            const image = resourceImage[resource.external_link.category];
            return (
              <Grid
                size={{ xs: 12, sm: 4, md: 3 }}
                key={resource.external_link.id}
              >
                <ResourceCard href="/dev/product-cards">
                  <ResourceCardHeader
                    image={{
                      src: image || bgPostgraduate,
                      alt: resource.external_link.category,
                      type: 'image',
                    }}
                  />
                  <ResourceCardContainer>
                    <ResourceCardTitle>
                      {resource.external_link.name}
                    </ResourceCardTitle>
                    <ResourceCardContent>
                      <ResourceCardMetaItem
                        icon={
                          externalResourceIconNames[
                            resource.external_link.category
                          ]
                        }
                      >
                        {resource.external_link.category}
                      </ResourceCardMetaItem>
                      {resource.external_link.source && (
                        <ResourceCardMetaItem icon="Public">
                          {resource.external_link.source}
                        </ResourceCardMetaItem>
                      )}
                    </ResourceCardContent>
                  </ResourceCardContainer>
                </ResourceCard>
              </Grid>
            );
          }

          return null;
        })}
      </Grid>
    </>
  );
};
